<template>
  <v-card elevation="0">
    <v-card-actions>
      <v-btn
        color="primary"
        :disabled="uploaded != null"
        @click.stop="aboutToUpload = true"
        block
        height="45px"
      >
        <v-icon>mdi-upload</v-icon> ЗАГРУЗИТЬ
      </v-btn>
    </v-card-actions>

    <v-dialog width="40%" v-model="aboutToUpload" persistent>
      <v-card>
        <v-card-title> Подтвердите начало загрузки </v-card-title>
        <v-card-text class="red--text">
          При потере соединения или при обновлении страницы во время загрузки
          убедитесь, что данные не были загружены!
        </v-card-text>
        <v-card-actions>
          <v-btn @click="aboutToUpload = false" color="error" outlined>
            ОТМЕНА
          </v-btn>
          <v-spacer />
          <v-btn
            @click="
              aboutToUpload = false;
              startUpload();
            "
            color="primary"
          >
            ОК
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    aboutToUpload: false,
  }),
  computed: {
    ...mapGetters(["uploaded"]),
    uploadedCheck() {
      return this.uploaded != null;
    },
  },
  methods: {
    ...mapActions(["upload"]),
    async startUpload() {
      this.$emit("loading-start", "Загрузка");
      await this.upload();
      this.$emit("loading-stop");
      this.$emit("cant-continue", !this.uploadedCheck);
    },
  },
  mounted() {
    this.$emit("cant-continue", !this.uploadedCheck);
  },
};
</script>